
import { useState } from "react";
//import { useNavigate } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CancelledBookingsReport } from "../../Services/ReportsApi";


const CancelledBookings = () => {
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        pnr: "",
        bookingRefNo: "",
        cancelationStatus: "",
    });

    //  const navigate = useNavigate();

    const today = new Date();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleDateChange = (name, date) => {
        if (!date) {
            setFilters((prev) => ({ ...prev, [name]: "" }));
            return;
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const formatted = `${day}/${month}/${year}`;

        setFilters((prev) => ({ ...prev, [name]: formatted }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                CancelationFromDate: filters.fromDate,
                CancelationToDate: filters.toDate,
                GDSPNR: filters.pnr,
                ReferenceNo: filters.bookingRefNo,
                CancellationStatus: filters.cancelationStatus,
                UserName: "",
            };

            const data = await CancelledBookingsReport(requestBody);
            console.log(data)
            const list = data?.allCancelledBookings || [];
            setTransactions(list);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reports</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Flight</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Cancellation</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filters */}
            <section className="wraper">
                <div className="box_shadow mt-14">
                    <div className="row">

                        {/* From Date */}
                        <div className="col-md-3 mb-3">
                            <label>Cancellation From Date</label>
                            <DatePicker
                                selected={parseDate(filters.fromDate)}
                                onChange={(date) => handleDateChange("fromDate", date)}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="From Date"
                                maxDate={today}
                                className="form-control form-control-solid"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Cancellation To Date</label>
                            <DatePicker
                                selected={parseDate(filters.toDate)}
                                onChange={(date) => handleDateChange("toDate", date)}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="To Date"
                                minDate={parseDate(filters.fromDate)}     // disable before fromDate
                                maxDate={today}                           // disable future dates
                                className="form-control form-control-solid"
                            />
                        </div>

                        {/* PNR */}
                        <div className="col-md-3 mb-3">
                            <label>PNR Number</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="pnr"
                                value={filters.pnr}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Booking RefNo */}
                        <div className="col-md-3 mb-3">
                            <label>Booking RefNo</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="bookingRefNo"
                                value={filters.bookingRefNo}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Cancelation Status</label>
                            <select
                                className="form-select form-select-solid"
                                name="bookingStatus"
                                value={filters.cancelationStatus}
                                onChange={handleChange}
                            >
                                <option value="">- Select -</option>
                                <option value="Cancel Under Process">Cancel Under Process</option>
                                <option value="Cancel Failed">Cancel Failed</option>
                                <option value="Refund Under Process">Refund Under Process</option>
                                <option value="Refund Processed">Refund Processed</option>
                            </select>
                        </div>

                        {/* Search Button */}
                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Results Table */}
            <section className="wraper">
                <div className="box_shadow">
                    <div className="table-responsive">
                        <table className="table align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="ps-4">Sr No</th>
                                    <th>Reference No</th>
                                    <th>PNR</th>
                                    <th>Airline</th>
                                    <th>Sector</th>
                                    <th>Travel Date</th>
                                    <th>Cancel Date</th>
                                    <th>Status</th>
                                    <th>Cancel Amount (₹)</th>
                                    <th>Refund Amount (₹)</th>
                                    <th>Refund Status</th>
                                    <th>Cancelation Id</th>
                                </tr>
                            </thead>

                            <tbody>
                                {transactions.length > 0 ? (
                                    transactions.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.referenceNo}</td>
                                            <td>{item.gDSPNR}</td>
                                            <td>{item.validatingCarrier}</td>
                                            <td>{item.origin} → {item.destination}</td>
                                            <td>{item.departureDate}</td>
                                            <td>{item.cancelDate}</td>
                                            <td>{item.cancelStatus}</td>
                                            <td>{item.cancellationCharge}</td>
                                            <td>{item.refundAmount}</td>
                                            <td>{item.refundStatus}</td>
                                            <td>{item.cancellationId}</td>

                                            {/* <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-light"
                                                    onClick={() =>
                                                        navigate(
                                                            `/Reservations/Flight/TransactionDetails?referenceNo=${item.referenceNo}`
                                                        )
                                                    }
                                                >
                                                    View
                                                </button>
                                            </td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center text-muted">
                                            {loading ? "Loading..." : "No records found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CancelledBookings;